import { Suspense } from 'react';
import type { ReactNode } from 'react';
import { Box, CircularProgress } from '@mui/material';

type FuseSuspenseProps = {
	children: ReactNode;
	loadingProps?: {
		delay?: number;
	};
};

/**
 * FuseSuspense component
 * React Suspense wrapper with default loading indicator
 */
function FuseSuspense(props: FuseSuspenseProps) {
	const { children } = props;

	return (
		<Suspense
			fallback={
				<Box
					sx={{
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						height: '100%',
						minHeight: '100vh',
					}}
				>
					<CircularProgress />
				</Box>
			}
		>
			{children}
		</Suspense>
	);
}

export default FuseSuspense;
